import React, { useState } from 'react'
import ModalFrame from '../common/ModalFrame'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Image from '../../images/ultimo-presupuesto-modal.png'
import "./ModalUltimoEditado.less"

export default function ModalUltimoEditado(props) {
  const { stateOpen, closeModal, onClick } = props
  const [checked, setChecked] = useState(false)

  return (
    <ModalFrame
      width={650}
      height={425}
      open={stateOpen}
      closeButton={true}
      onCloseModal={closeModal}
      title="Último presupuesto editado"
    >
        <div className="modal-ultimo-editado_body">
          <p>Este presupuesto quedará provisoriamente en<br/>
            <b>"Último editado"</b> dentro del menú principal.
          </p>
          <img src={Image} alt="ayuda"></img>
          <FormControlLabel
          control={
          <Checkbox
            checked={checked}
            onChange={() => setChecked(!checked)}
            name="checked"
            color="primary"
          />
        }
        label="No volver a mostrar este mensaje"
      />
          <div className="boton-entendido">
            <Button onClick={() => onClick(checked)}>Entendido</Button>
          </div>
        </div>
    </ModalFrame>
  )
}
